<template>
  <div v-if="imageMap" class="imageMap">
    <img :src="`${imageMap.urlTemplate}${imageMap.filePath}`" :alt="imageMap.alt" usemap="#map4359010" plate />
  </div>
</template>

<script setup>
defineProps({
  imageMap: {
    type: Object,
    default: null,
  },
});
</script>

<style lang="scss" scoped>
.imageMap-container {
  .imageMap {
    width: rem-calc(530);
  }
}
@media only screen and (max-width: rem-calc(400)) {
  .imageMap-container {
    .imageMap {
      width: rem-calc(360);
    }
  }
}
</style>
